import { linkStrategy, linkStrategyCTA } from '@/App.datalayer';
import { isLinkIgnoredByPosition } from '@/datalayer/App.datalayer.utils';
import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

enum Selectors {
  // Target
  CTALink = '.gtm-campaign-header-cta a',
  CTAButton = '.gtm-campaign-header-cta button',
  // Containers
  CTAcontainer = '.gtm-campaign-header-cta',
}

export const mapTarget = mapTargetBySelectors([Selectors.CTALink, Selectors.CTAButton]);

export const onDatalayer = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const isCTA = target?.closest(Selectors.CTAcontainer);
  const href = target?.href || '';
  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  if (isCTA) {
    return {
      event: 'clickCTA',
      eventCategory: 'Campaign Header',
      href,
      // TODO: verify
      ...(variantName && { variant_name: variantName }),
    };
  }

  return undefined;
};

export const onDatalayerClickLink = ({ target }: OnDatalayerProps) => {
  if (
    target?.getAttribute('data-datalayer-ignore-link') ||
    isLinkIgnoredByPosition({ target, position: 'campaign_header' })
  )
    return undefined;

  const variantName = target?.closest('[data-datalayer-variant]')?.dataset?.datalayerVariant || '';
  return linkStrategy({ target, position: 'campaign_header', variant: variantName });
};

export const onDatalayerClickCTA = ({ target }: OnDatalayerProps) => {
  if (target?.getAttribute('data-datalayer-ignore-cta')) return undefined;

  const variantName = target?.closest('[data-datalayer-variant]')?.dataset?.datalayerVariant || '';
  return linkStrategyCTA({ target, position: 'campaign_header', variant: variantName });
};
